// A Select elevation has no style; a Signature one is named by its style.

import type { CatalogElevation } from '../../../../shared/utils/elevation-catalog';

export const isSelect = (elevation: CatalogElevation): boolean => elevation.fields.style == null;

export const isSignature = (elevation: CatalogElevation): boolean => !isSelect(elevation);

export const onPlans = (plans: string[]) => (elevation: CatalogElevation): boolean =>
  Boolean(elevation.plan) && plans.includes(elevation.plan!.slug);
